module.exports = ".close {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n    padding: 0px !important;\r\n    width: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/_directive/error-popup/error-popup.component.css
// module id = ./src/app/sharedcomponents/_directive/error-popup/error-popup.component.css
// module chunks = main